module.exports = __webpack_public_path__ + "static/media/10A.9a0c2fde.png";